/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Container from 'blocks/Container/Container';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';

const StyledContainer = styled(Container)`
  margin-top: 125px;
  padding: 0 20px;
`;

@inject("coreStore")
@observer
export default class Regulations extends Component {
  render() {
    const { coreStore: { translations }, isAppRegulations } = this.props;
    return (
      <StyledContainer
        dangerouslySetInnerHTML={{ __html: isAppRegulations ? translations.APPLICATION_REGULATIONS : translations.REGULATIONS }}
      />
    );
  }
}

Regulations.propTypes = {
  isAppRegulations: PropTypes.bool,
};

Regulations.defaultProps = {
  isAppRegulations: false,
};



// WEBPACK FOOTER //
// ./src/blocks/Regulations/index.jsx